export namespace StringUtils {

    export function capitalizeFirstLetter(str: string): string {
        if (!str) return str;
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    export function titleCase(str: string): string {
        if (!str) return str;
        return str.split(' ').map(word => capitalizeFirstLetter(word.toLowerCase())).join(' ');
    }
}